import { createSlice } from "@reduxjs/toolkit";
import type { VersionInfo } from "@arcgis/core/versionManagement/support/jsonTypes";

interface VersionState {
    activeGuid: string;
    readActive: boolean;
    editActive: boolean;
    versionInfo: VersionInfo | null;
    versionsSharedWithMe: string[] | null;
}

const initialState: VersionState = {
    activeGuid: "",
    readActive: false,
    editActive: false,
    versionInfo: null,
    versionsSharedWithMe: [],
};

const versionSlice = createSlice({
    name: "version",
    initialState,
    reducers: {
        setActiveGuid(state, action) {
            state.activeGuid = action.payload;
        },
        setReadActive(state, action) {
            state.readActive = action.payload;
        },
        setEditActive(state, action) {
            state.editActive = action.payload;
        },
        setVersionInfo(state, action) {
            state.versionInfo = action.payload;
        },
        setVersionsSharedWithMe(state, action) {
            state.versionsSharedWithMe = action.payload;
        }
    },
});

export default versionSlice.reducer;
export const {
    setActiveGuid,
    setReadActive,
    setEditActive,
    setVersionInfo,
    setVersionsSharedWithMe,
} = versionSlice.actions;
export type { VersionState };
